import dayjs from '@/services/date'
export default {
  methods: {
    renderDate(dateTime, timeZone, format = null) {
      let date = dayjs(dateTime).tz(timeZone)
      date = format == null ? date : date.format(format)
      return this.$d(date)
    },
    renderTime(dateTime) {
      const time = dayjs(dateTime)
      return this.$d(time, 'time')
    },
    renderTime24(dateTime) {
      const time = dayjs(dateTime)
      return this.$d(time, 'time24')
    },
  },
}
